export default defineNuxtRouteMiddleware((_, { fullPath, name, params, path, query }) => {
  const route = usePrevRoute()
  route.value = { fullPath, name: myLinkName({ name }), params, path, query }
})
